export default __webpack_public_path__ + "static/media/uploudlist.bc072739.svg";